import { reportError } from "lib/errorReporter"

const env = process.env.NODE_ENV

// 本番では **送信先に送る**（#422）。以前は `firstErrorObject` を計算して捨てていたので、
// #412 / #414 / #417 / #420 の fail-open が文字どおり「黙って素通し」になっていた。
//
// 呼び出し側の形は `logger(tag, { productName, planType }, new Error(...))`。
// **タグも文脈オブジェクトも落とさずに運ぶ。**
// Error が 1 つも無い呼び出し（`logger("profile", res)` のような情報ログ）は送らない。
export default (tag: string, ...msg: any[]) => {
  const firstErrorObject = msg.find((m) => m instanceof Error)

  if (env !== "production") {
    const css = "background: rgba(0,0,255,0.3); color:white; padding: 2px"
    console.log("%c%s", css, tag, ...msg)

    return
  }

  if (firstErrorObject) {
    reportError({
      tag: tag,
      error: firstErrorObject,
      // ★ **2 つ目以降の Error はここで落ちます**（#426 のレビューで出た指摘 / #431 で記録）。
      //   `logger(tag, err, cause)` の形が将来出ると `cause` が消えます。
      //   **このツリーの呼び出し側は、どれも引数が最大 2 つ**（タグ + 値 1 つ）で、
      //   Error を渡しているのは 23 箇所ありますが、**2 つ目の Error を渡す形は 1 本もありません**
      //   ので実害はありません。`logger(tag, { ... }, new Error(...))` の 3 引数形も、
      //   このツリーではコメントと spec にしか存在しません（課金まわりで 3 引数形を使う
      //   #412 / #414 / #417 / #420 は **別チェーン**で、この PR の祖先に入っていません）。
      //
      //   ⚠️ **`m !== firstErrorObject` に変えるだけで直したつもりにならないこと。**
      //   `JSON.stringify(new Error("cause detail"))` は **`"{}"`** なので
      //   （Node 18.18.2 で実測）、mixpanel には **空オブジェクトが届きます**。
      //   「cause を捕まえたように見えて中身が空」になり、黙って捨てるより悪い。
      //   直すなら `name` / `message` / `stack` を明示的に詰めること。
      context: msg.filter((m) => !(m instanceof Error)),
    })
  }
}
